/** @format */
import { errorServiceModule } from '../error-handler/legacy/errorService';
import { localizedStringEditorModule } from '../string/localizedStringEditor.dir';
import substitutionTpl from './substitution.tpl.html';

export const substitutionModule = 'sis-components.courseUnit.substitution';

(function () {
    substitutionController.$inject = ['courseUnitInfoModal', 'commonCourseUnitService', 'defaultPromiseHandler'];
    angular
        .module(substitutionModule, [
            'pascalprecht.translate',
            errorServiceModule,
            'sis-components.number.creditRangeFilter',
            'sis-components.service.courseUnitService',
            localizedStringEditorModule,
            'sis-components.model.courseUnit',
        ])
        .component('substitution', {
            template: substitutionTpl,
            transclude: true,
            bindings: {
                substitution: '<',
                colorIndex: '<',
            },
            controller: substitutionController,
        });

    function substitutionController(courseUnitInfoModal, commonCourseUnitService, defaultPromiseHandler) {
        var $ctrl = this;
        $ctrl.$onChanges = function () {
            getSubstitutionCourseUnits();
        };

        function getSubstitutionCourseUnits() {
            _.forEach($ctrl.substitution, function (courseUnitSubstitution) {
                commonCourseUnitService.findByGroupId(courseUnitSubstitution.courseUnitGroupId, undefined).then(function (courseUnit) {
                    courseUnitSubstitution._courseUnit = courseUnit;
                });
            });
        }

        $ctrl.openCourseUnitInfoModal = function (courseUnitId) {
            courseUnitInfoModal.open(courseUnitId).then(angular.noop).catch(defaultPromiseHandler.loggingRejectedPromiseHandler);
        };
    }
})();
